<template>
    <div class="form-group" :class="{'input-group': hasIcon}">

        <slot name="label">
            <label v-if="label" class="control-label" :for="cusName">
                {{label}}
            </label>
        </slot>

        <div class="col-md-12 text-center" v-show="renderImg">
            <div class="card m-3" style="width: 50%;display: inline-block;">
                <img class="card-img-top" :src="renderImg" alt="Event Image" style="object-fit: cover;">
            </div>
        </div>

        <slot name="addonLeft">
          <span v-if="addonLeftIcon" class="input-group-addon">
            <i :class="addonLeftIcon"></i>
          </span>
        </slot>

        <input
                :type="type"
                @change="previewThumbnail"
                v-bind="$attrs"
                class="form-control"
                aria-describedby="addon-right addon-left"
                :class="{'is-invalid': hasErrors && hasErrors.has(cusName), 'is-valid': isInputValid()}"
                :id="cusName"
                :name="cusName"
                accept="image/x-png,image/gif,image/jpeg"
                >

        <slot></slot>

        <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon">
        <i :class="addonRightIcon"></i>
      </span>
        </slot>

        <div v-show="hasErrors && hasErrors.has(cusName)" class="invalid-feedback">{{ hasErrors && hasErrors.first(cusName) }}</div>

    </div>
</template>
<script>
    export default {
        inheritAttrs: false,
        name: 'fg-image',
        data(){
        return {
            imgPath: ''
        }
    },
    /*props: {
     hasErrors: {},
     isFields: {},
     cusName:String,
     newImage:String,
     type: String,
     label: String,
     value: Any,
     addonRightIcon: String,
     addonLeftIcon: String
     },*/
    props: [
        'hasErrors',
        'isFields',
        'cusName',
        /*'newImage',*/
        'type',
        'label',
        'value',
        'addonRightIcon',
        'addonLeftIcon'
    ],
    methods:{
        previewThumbnail(event){
            let input = event.target;
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                reader.onload = (function (cb) { // here we save variable 'file' in closure
                    return function (e) { // return handler function for 'onload' event
                        cb(e.target.result)
                    }
                })((path)=>{
                    this.imgPath = path;
                    let files = Array.from(input.files);
                    this.inputEvent('file', files);
                });
                reader.readAsDataURL(input.files[0]);
            }
        },
        isInputValid(){
            var boolean = false;
            if(this.isFields && this.isFields[this.cusName]){
                boolean = this.isFields[this.cusName].valid;
            }
            return boolean;
        },
        inputEvent(name, value){
            this.isInputValid()
            this.imgPath && this.$emit(name, {value: value, path: this.imgPath});
        }
    },
    computed: {
        hasIcon () {
            const {addonRight, addonLeft} = this.$slots;
            return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
        },
        renderImg(){
            if(this.imgPath) return this.imgPath;
            return this.value
        }
    }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/formGroupImageSelect.vue